module.exports = __webpack_public_path__ + "img/icon-01.366e73d6.svg";